import React from "react"

class GrantHeaderComponent extends React.Component {

	render() {
		return (
			<div className="grant-header-row">
				{this.props.row.title}
				<div className="grant-actions">
					<button onClick={this._handleClick.bind(this)} title="Modifier la subvention"><i className="fa fa-edit" /></button>
					<button onClick={this._handleDeleteClick.bind(this)} title="Supprimer la subvention"><i className="fa fa-trash" /></button>
					<button onClick={this._handleToggleClick.bind(this)} title={(this.props.row.grant.awarded ? "Désoctroyer" : "Octroyer") + " la subvention"}><i className={"fa fa-" + (this.props.row.grant.awarded ? "ban" : "check")} /></button>
				</div>
			</div>
		)
	}

	_handleClick() {
		this.props.onCustomAction("alter_grant", {grant: this.props.row.grant, project: this.props.row.project})
	}

	_handleDeleteClick() {
		this.props.onCustomAction("destroy_grant", {grant: this.props.row.grant, project: this.props.row.project})
	}

	_handleToggleClick() {
		this.props.onCustomAction("toggle_grant", {grant: this.props.row.grant, project: this.props.row.project})
	}

}

export default GrantHeaderComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/grants/header-component.js